import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from './toast.service';
import { ToastItem } from './toast.model';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss'
})
export class ToastContainerComponent {
  constructor(public toast: ToastService) {}

  trackById(_: number, item: ToastItem) {
    return item.id;
  }

  dismiss(id: string) {
    this.toast.dismiss(id);
  }
}

